import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ScrollToTopMessage } from "./utils/send-message/send-message";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    ScrollToTopMessage();
  }, [pathname]);

  return null;
}
